import { useCallback } from 'react';

import { usePermissions } from '@work4all/data';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useCanFilterEntitiesByPermission = () => {
  const { canAdd } = usePermissions();

  const filterEntitiesByPermission = useCallback(
    (entity: Entities) => {
      return canAdd({ entity });
    },
    [canAdd]
  );

  return { filterEntitiesByPermission };
};
